import React from 'react';
import { ExternalLink } from 'lucide-react';

export const SponsorCard = ({ sponsor, buttonText = "KAYDOL, 2500TL KAZAN!" }) => {
  return (
    <div className="sponsor-card" data-testid={`sponsor-card-${sponsor.id}`}>
      <div className="sponsor-card-logo">
        <img src={sponsor.logo} alt={sponsor.name} loading="lazy" />
      </div>
      <div className="sponsor-card-content">
        <span className="sponsor-card-badge">{sponsor.badge}</span>
        <h3 className="sponsor-card-name">{sponsor.name}</h3>
        <p className="sponsor-card-desc">{sponsor.description}</p>
        <a
          href={sponsor.affiliateUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="sponsor-visit-btn"
          data-testid={`sponsor-card-${sponsor.id}-visit-button`}
          aria-label={`${sponsor.name} - Yeni sekmede acilir`}
        >
          {buttonText} <ExternalLink size={14} />
        </a>
      </div>
    </div>
  );
};
